import { render, staticRenderFns } from "./tip-edit.vue?vue&type=template&id=77f6e5c4&scoped=true&"
import script from "./tip-edit.vue?vue&type=script&lang=js&"
export * from "./tip-edit.vue?vue&type=script&lang=js&"
import style0 from "./tip-edit.vue?vue&type=style&index=0&id=77f6e5c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6e5c4",
  null
  
)

export default component.exports